import { mediacoreApi } from '@apis/mediacoreApi'
import {
  createOneMutation,
  deleteByIdMutation,
  getByIdAndClientIdQuery,
  pkSubEndpointMutation,
  updateByIdMutation,
} from '@apis/mediacoreQueries'
import { GalleryPayload, Position } from '@types'
const positionsEndpointURL = 'jobs/posiciones'

const positionsApi = mediacoreApi.injectEndpoints({
  endpoints: (builder) => ({
    getPositionById: builder.query<Position, { id: number; clientId: number }>({
      query: getByIdAndClientIdQuery(positionsEndpointURL),
      providesTags: (_result, _error, { id }) => [{ type: 'Position', id }],
    }),
    deletePosition: builder.mutation<Position, { id: number; clientId: number }>({
      query: deleteByIdMutation(positionsEndpointURL),
      invalidatesTags: ['PositionTable'],
    }),
    createPosition: builder.mutation<Position, { data: Partial<Position> }>({
      query: createOneMutation(positionsEndpointURL),
      invalidatesTags: ['PositionTable'],
    }),
    updatePosition: builder.mutation<Position, { id: number; data: Partial<Position> }>({
      query: updateByIdMutation(positionsEndpointURL),
      invalidatesTags: ['PositionTable'],
      async onQueryStarted({ id }, { dispatch, queryFulfilled }) {
        try {
          const { data: updatedPosition } = await queryFulfilled
          dispatch(
            positionsApi.util.updateQueryData('getPositionById', { id, clientId: updatedPosition.client }, (draft) => {
              Object.assign(draft, updatedPosition)
            }),
          )
        } catch {}
      },
    }),
    uploadPositionImages: builder.mutation<unknown, { id: number; data: GalleryPayload }>({
      query: pkSubEndpointMutation(positionsEndpointURL, 'galeria'),
      invalidatesTags: ['PositionTable', 'Position'],
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetPositionByIdQuery,
  useDeletePositionMutation,
  useCreatePositionMutation,
  useUpdatePositionMutation,
  useUploadPositionImagesMutation,
} = positionsApi
